export type SeatPrecheckItem = {
  eventId: string;
  ticketId: string;
  count: number;
};

/**
 * 連番が確保できない item が1つでもあれば true。
 * count=-1（制約なし）と count>=希望数 は確認不要。
 */
export const needsNonConsecutiveConsent = (
  items: SeatPrecheckItem[],
  counts: number[]
): boolean =>
  counts.some(
    (available, i) => available >= 0 && available < (items[i]?.count ?? 0)
  );
